import { cn } from '@/lib/utils';

interface IPageContainerProps {
	children: any;
	className?: string;
}

export const PageContainer = ({ children, className }: IPageContainerProps) => {
	return (
		<div className={cn(
			"w-full max-w-[1680px] mx-auto px-2 sm:px-4 lg:px-4 py-2.5 lg:py-3.5",
	            "animate-in fade-in slide-in-from-bottom-2 duration-500 ease-out",
			className
		)}>
			{children}
		</div>
	);
};
